import { render, staticRenderFns } from "./SubscriptionSettings.vue?vue&type=template&id=e68c22d0&scoped=true&"
import script from "./SubscriptionSettings.vue?vue&type=script&lang=js&"
export * from "./SubscriptionSettings.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionSettings.vue?vue&type=style&index=0&id=e68c22d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68c22d0",
  null
  
)

export default component.exports